import * as React from "react";
const SvgFiRrIcicles = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-icicles_svg__a)">
      <path
        fill="#062147"
        d="M8 24h-.024a1 1 0 0 1-.956-.804L5 13.098l-1.02 5.098c-.096.479-.538.831-1.013.803a1 1 0 0 1-.96-.866L.044 3.473a2.93 2.93 0 0 1 .644-2.397A2.97 2.97 0 0 1 2.977 0h18.047a2.973 2.973 0 0 1 2.931 3.49l-2.972 18.209a1 1 0 0 1-.96.839c-.513-.008-.9-.316-1.004-.784l-2.104-9.505-1.45 5.507a1 1 0 0 1-.955.745c-.473-.017-.85-.292-.973-.725l-1.695-5.927-2.873 11.396a1 1 0 0 1-.97.756zM5 7a1 1 0 0 1 .98.804l2.132 10.66 2.7-10.708A1 1 0 0 1 11.766 7c.437-.019.853.29.978.725l1.716 5.999 1.573-5.979a1.001 1.001 0 0 1 1.943.039l1.87 8.454 2.136-13.083a.97.97 0 0 0-.212-.807.96.96 0 0 0-.747-.349H2.977a.96.96 0 0 0-.751.353.96.96 0 0 0-.208.804l1.177 8.773.825-4.126A1 1 0 0 1 5 7"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-icicles_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrIcicles;
